

























































































import { Component, Vue, Prop } from 'vue-property-decorator';
import DepartmentInfo from './Service/DepartmentInfo';
import DoCreate from './Service/doCreate';
import applyForm from './form';

@Component
export default class roleCreate extends Vue {
  private applyForm: Object = applyForm;

  private form: Object = {};

  private DepartmentInfo: Array<Object> = [];

  private keepCreate: boolean = false; // 判定: 繼續新增

  /** 取得列表 */
  public async getCreate(params?: object) {
    const getter = (await new DepartmentInfo().get()) as any;
    this.DepartmentInfo = getter;
  }

  /** 送出表單 */
  public async submitForm(formName: string) {
    /** 測試模式判定 */
    const myForm: any = this.$refs[formName];
    myForm.validate(async (valid: boolean) => {
      if (valid) {
        const getter = (await new DoCreate(this.form).post()) as any;
        if (getter.data.code === 0) {
          if (!this.keepCreate) {
            this.$router.push('/transaction/apply/lists');
          }
          this.keepCreate = false;
          this.resetForm(formName);
        }
      } else {
        const msg: any = this.$t('Util.validateError');
        this.$message.error(msg);
      }
    });
  }

  /** 清除表單 */
  private resetForm(formName: string) {
    const myForm: any = this.$refs[formName];
    myForm.resetFields();
  }

  private mounted() {
    this.getCreate();
    this.$bus.$on('saveAndGo', () => {
      this.submitForm('form');
    });

    this.$bus.$on('keepCreate', () => {
      this.keepCreate = true;
      this.submitForm('form');
    });
  }
}
